import React from 'react';
const Header=()=>{
    return(
        <header>
            <h2>Welcome to Your TODO App</h2>
        </header>
    )
}
export default Header;